import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { targetPixelSize } from '../../utilities/fluid-design';
import { breakpoints } from '../../core/constants';

gsap.registerPlugin(ScrollTrigger);

export default class Marquee {
    constructor(element, options = {}) {
        if (!element) return;

        this.element = element;
        this.options = options;

        return this.init();
    }

    init() {
        return this.marquee();
    }

    marquee() {
        // Add your own animation logic here
        let containerPadding = targetPixelSize() * 24;

        if (window.matchMedia(`(min-width: ${breakpoints.lg}px)`).matches) {
            containerPadding = targetPixelSize() * 72;
        }

        const titleWidth = this.element.offsetWidth + containerPadding;

        const marqueeAnimation = gsap.fromTo(this.element, {
            x: containerPadding,
        }, {
            x: 0 - (titleWidth - window.innerWidth),
            scrollTrigger: {
                trigger: this.element.closest('.pane'),
                start: this.options.start || 'top 66.66666%',
                end: this.options.end || 'bottom 33.33333%',
                scrub: 1,
                markers: this.options.markers || false,
                preventOverlaps: true,
            },
        });


        return marqueeAnimation;
    }
}
